import API from '../../sunpalApi';
const ENTITY = 'proposals';

export const getElectricBills = (offerId) =>
    API.get(`/api/v1/${ENTITY}/electricbill/${offerId}/`);

export const getInteractiveProposal = (offerId) =>
    API.get(`/api/v1/${ENTITY}/interactive/${offerId}/`);

export const getInteractiveProposalContent = (offerId) =>
    API.get(`/api/v1/${ENTITY}/proposal/${offerId}/`);

export const getSmarDocumentContent = (documentId) =>
    API.get(`/api/v1/${ENTITY}/document/${documentId}/`);
